import styled from '@emotion/styled';
import { Wws_Page } from '../../../../../types/graphql';
import { useCallback } from 'react';
import { getSectionId } from '../../../../Templates/SinglePageTemplate';
import SinglePageDesktopNavMenuItem from './SinglePageDesktopNavMenuItem';
import useTracking from '../../../../../lib/useTracking';
import { useActiveSinglePageSectionContext } from '../../../../../context/ActiveSinglePageSectionContext';

interface NavMenuWrapperProps {
  isMenuOpen: boolean;
}

const NavMenuWrapper = styled('div')`
  scale: 1 0;
  opacity: 0;
  translate: 0 -60%;
  transition: all 0.3s ease-in-out;

  ${({ isMenuOpen }: NavMenuWrapperProps): string =>
    isMenuOpen
      ? `      scale: 1 1;
      opacity: 1;
      translate: 0 0;`
      : ''}
`;

const NavMenuContainer = styled('div')`
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  filter: drop-shadow(0px 5px 12px rgba(0, 0, 0, 0.16))
    drop-shadow(0px 3px 12px rgba(0, 0, 0, 0.14));

  display: flex;
  flex-direction: column;
  row-gap: 24px;
  align-items: start;
  min-width: 300px;
  max-width: 500px;
`;

interface SinglePageDesktopNavMenuProps {
  pages?: Wws_Page[];
  isMenuOpen?: boolean;
  setIsMenuOpen: (isOpen: boolean) => void;
}

const SinglePageDesktopNavMenu = ({
  pages = [],
  isMenuOpen = false,
  setIsMenuOpen,
}: SinglePageDesktopNavMenuProps) => {
  const { activeSectionId } = useActiveSinglePageSectionContext();

  const userDecisionArea = 'desktop nav';
  const currentRoute = activeSectionId || '';

  const trackGuest = useTracking('guest', currentRoute, userDecisionArea);
  const trackRsvp = useTracking('rsvp', currentRoute, userDecisionArea);

  const handleTracking = useCallback(
    (newRoute: string): void => {
      if (newRoute === 'rsvp') {
        trackRsvp(newRoute, '');
      }

      trackGuest(newRoute, '');
    },
    [trackGuest, trackRsvp]
  );

  return (
    <NavMenuWrapper
      isMenuOpen={isMenuOpen}
      data-testid="SinglePageDesktopNav__NavMenu__Wrapper"
    >
      <NavMenuContainer>
        {pages.map((page) => (
          <SinglePageDesktopNavMenuItem
            key={page.id}
            page={page}
            onClick={() => setIsMenuOpen(false)}
            isActive={activeSectionId === getSectionId(page)}
            handleTracking={handleTracking}
          />
        ))}
      </NavMenuContainer>
    </NavMenuWrapper>
  );
};

export default SinglePageDesktopNavMenu;
